import React, { useState } from 'react';
import styled from 'styled-components';
import RightNav from './RightNav';

const StyledBurger = styled.div`
  width: 30px;          /* antes 22px */
  height: 24px;         /* antes 22px */
  display: none;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  z-index: 1101;

  @media (max-width: 1024px) {
    display: flex;
  }

  div {
    height: 3px;
    border-radius: 5px;
    background-color: ${({ open }) => (open ? "#7a3075" : "#4a1942")};
    transition: all 0.3s linear;
    transform-origin: 1px;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      opacity: ${({ open }) => (open ? 0 : 1)};
      transform: ${({ open }) => (open ? "translateX(10px)" : "translateX(0)")};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;



const Burger = () => {
  const [open, setOpen] = useState(false);

  const changeStateBurger = () => {
    setOpen(!open);
  };

  return (
    <>
      <StyledBurger open={open} onClick={changeStateBurger}>
        <div />
        <div />
        <div />
      </StyledBurger>

      <RightNav open={open} changeStateBurger={changeStateBurger} />
    </>
  );
};

export default Burger;
